import React, { useEffect, useCallback } from 'react';
import './Lightbox.css';

const Lightbox = ({ isOpen, imageSrc, imageAlt, mediaType = 'image', onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleKeyDown);
      
      return () => {
        document.body.style.overflow = '';
        document.removeEventListener('keydown', handleKeyDown);
      };
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="lightbox-overlay" onClick={handleOverlayClick}>
      <div className="lightbox-content">
        <button className="lightbox-close" onClick={onClose} aria-label="Close lightbox">
          ×
        </button>
        {mediaType == 'video' ? (
          <video
            src={imageSrc}
            className="lightbox-video"
            controls
            autoPlay
            playsInline
          />
        ) : (
          <img src={imageSrc} alt={imageAlt} className="lightbox-image" />
        )}
      </div>
    </div>
  );
};

export default Lightbox;